import fb from '../../firebaseConfig.js';
import { CURRENCIES, CURRENT_USER, SET_CURRENCIES } from '../constants';
import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    [CURRENCIES]: []
  },
  actions: {
    async getCurrencies({ commit, rootState }) {
      try {
        const items = [];
        let response = await fb.users
          .doc(rootState.auth[CURRENT_USER].uid)
          .collection('currencies')
          .get();
        response.docs.map(d => {
          items.push({ ...d.data() });
        });
        commit(SET_CURRENCIES, items);
        return items;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while fetching categories.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async createCurrency({ commit, state, rootState, dispatch }, { currencies, defaultCurrency }) {
      try {
        debugger;
        const uid = rootState.auth[CURRENT_USER].uid;
        const batch = fb.db.batch();
        batch.update(fb.users.doc(uid), {
          'hasConfigured.currencies': true,
          defaultCurrency
        });
        const items = [];
        currencies.forEach(currency => {
          const docRef = fb.users
            .doc(uid)
            .collection('currencies')
            .doc();
          const tmp = {
            id: docRef.path,
            key: currency.key,
            symbol: currency.symbol,
            name: currency.name
          };
          batch.set(docRef, tmp);
          items.push(tmp);
        });
        await batch.commit();
        dispatch('auth/fetchUserProfile', null, { root: true });
        commit(SET_CURRENCIES, state[CURRENCIES].concat(items));
        return batch;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while saving currencies.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async deleteCurrency({ commit, state, rootState, dispatch }, { id, defaultCurrency }) {
      try {
        const batch = fb.db.batch();
        batch.update(fb.users.doc(rootState.auth[CURRENT_USER].uid), {
          defaultCurrency
        });
        batch.delete(fb.users.doc(id.replace('users/', '')));
        await batch.commit();
        dispatch('auth/fetchUserProfile', null, { root: true });
        commit(
          SET_CURRENCIES,
          state[CURRENCIES].filter(d => d.id !== id)
        );
        return batch;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while saving currencies.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    },
    async updateDefaultCurrency({ commit, state, rootState, dispatch }, defaultCurrency) {
      try {
        const uid = rootState.auth[CURRENT_USER].uid;
        const batch = fb.db.batch();
        batch.update(fb.users.doc(uid), {
          defaultCurrency
        });
        await batch.commit();
        dispatch('auth/fetchUserProfile', null, { root: true });
        commit(SET_CURRENCIES, state[CURRENCIES]);
        return batch;
      } catch (error) {
        Vue.prototype.$notification.error({
          message: 'Ooops! Something went wrong while saving currencies.',
          description: error.message,
          placement: 'bottomLeft'
        });
        throw error;
      }
    }
  },
  mutations: {
    [SET_CURRENCIES]: (s, d) => (s[CURRENCIES] = d)
  }
};
